var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPersonAdminBlue = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/24/person"
  }, /*#__PURE__*/React.createElement("path", {
    id: "person",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12ZM12 10C10.3431 10 9 8.65685 9 7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7C15 8.65685 13.6569 10 12 10ZM3 22.0035C2.44772 22.0035 2 21.5558 2 21.0035C2 16.5745 5.59041 12.9841 10.0194 12.9841H13.9806C18.4096 12.9841 22 16.5745 22 21.0035C22 21.5558 21.5523 22.0035 21 22.0035H3ZM10.0194 14.9841C7.03567 14.9841 4.55897 17.1551 4.08268 20.0035H19.9173C19.441 17.1551 16.9643 14.9841 13.9806 14.9841H10.0194Z",
    fill: "#1e3867"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPersonAdminBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/person-admin-blue.4e248e66733f41d8a7de1c064219ba8c.svg";